import type { ConfigurationContextValue } from "../root/ConfigurationContext";
import type { Company } from "../types";

export type CompaniesByStage = Record<string, Company[]>;

export const getCompaniesByStage = (
  unorderedCompanies: Company[],
  companyLifecycleStages: ConfigurationContextValue["companyLifecycleStages"],
) => {
  if (!companyLifecycleStages) return {};
  const companiesByStage: CompaniesByStage = unorderedCompanies.reduce(
    (acc, company) => {
      // if company has a stage that does not exist in configuration, assign it to the first stage
      const stage = companyLifecycleStages.find(
        (s) => s.value === company.lifecycle_stage,
      )
        ? company.lifecycle_stage || companyLifecycleStages[0].value
        : companyLifecycleStages[0].value;

      // Ensure the stage exists in the accumulator, if not default to first stage
      if (!acc[stage]) {
        acc[companyLifecycleStages[0].value].push(company);
      } else {
        acc[stage].push(company);
      }
      return acc;
    },
    companyLifecycleStages.reduce(
      (obj, stage) => ({ ...obj, [stage.value]: [] }),
      {} as CompaniesByStage,
    ),
  );
  // order each column by index
  companyLifecycleStages.forEach((stage) => {
    companiesByStage[stage.value] = companiesByStage[stage.value].sort(
      (recordA: Company, recordB: Company) =>
        (recordA.index || 0) - (recordB.index || 0),
    );
  });
  return companiesByStage;
};
